import tpv from './base';

import { i18nEPG } from './epgi18n';

export const url = {
  stage: {
    scriptTag: 'https://epgjs-rendercashier-stg.easypaymentgateway.com/js/public/epgjs-3.9.0-min.js',
    cashier: 'https://epgjs-web-stg.easypaymentgateway.com/',
    originCashier: 'https://epgjs-rendercashier-stg.easypaymentgateway.com'
  },
  prod: {
    scriptTag: 'https://epgjs-rendercashier.easypaymentgateway.com/js/public/epgjs-3.9.0-min.js',
    cashier: 'https://epgjs-web.easypaymentgateway.com/',
    originCashier: 'https://epgjs-rendercashier.easypaymentgateway.com'
  }
};

export const checkInputValidity = inputID => {
  const validField = window.document.getElementById(inputID).validity.valid;
  const element = window.document.querySelector('#' + inputID + '-div');
  if (element) {
    if (validField) {
      element.style.border = '1px solid #ddd';
    } else {
      element.style.border = '1px solid #f00';
    }
  }
  return validField;
};

export default class EPG_BASE extends tpv {
  /** @type {'stage'|'prod'} */
  environment = 'stage';
  /** @type {string} */
  cashierContainer = 'EPGCashierContainer';
  /** @type {HTMLElement|null} */
  scriptTag = null;
  /** @type {Promise|null} */
  scriptTagPromise = null;
  /** @type {boolean} */
  validPAN = false;
  /** @type {string} */
  form = 'epgjs-cashier-quickpay-form';
  /** @type {string} */
  submitButton = 'epgjs-cashier-quickpay-form-button-CreditCards';
  /** @type {string} */
  holderNameInput = 'epgjs-cashier-quickpay-form-field-creditcards-chname';
  /** @type {string} */
  rememberMeInput = 'epgjs-cashier-quickpay-form-field-creditcards-rememberme';
  /** @type {string} */
  expireDateInput = 'epgjs-cashier-quickpay-form-field-creditcards-expdate';
  /** @type {string} */
  cvcInput = 'epgjs-cashier-quickpay-form-field-creditcards-cvnnumber';
  /** @type {string} */
  cardNumberInput = 'epgjs-cashier-quickpay-form-field-creditcards-cardnumber';
  /** @type {boolean|Promise} */
  loadingTpvAuth = false;
  /** @type {boolean|string} */
  prepayToken = false;
  /** @type {number} */
  nRetry = 0;
  /** @type {number} */
  authRetries = 0;
  /** @type {null|string} */
  paymentToken = null;
  /** @type {boolean|function} */
  successEvent = false;
  /** @type {boolean|function} */
  onSubmitPromiseResolve = false;
  /** @type {boolean|function} */
  onSubmitPromiseReject = false;
  /** @type {boolean} */
  emailSent = false;
  /** @type {boolean} */
  firstLoad = true;
  /** @type {boolean} */
  panInputLoaded = false;
  /** @type {boolean} */
  fieldsCustomized = false;

  /**
   *
   * @param environment {string}
   */
  constructor(
    environment
  ) {
    super();
    this.environment = environment;

    this.scriptTagPromise = new Promise((resolve, reject) => {
      this.scriptTag = this.addScriptTag();

      const onErrorFunc = () => {
        setTimeout(() => {
          this.scriptTag = this.addScriptTag();
          this.scriptTag.onerror = onErrorFunc;
          this.scriptTag.onload = onLoadFunc;
        }, 1000);
      };

      const onLoadFunc = () => {
        resolve('ok');
      };

      this.scriptTag.onerror = onErrorFunc;
      this.scriptTag.onload = onLoadFunc;
    });

  }

  /**
   *
   * @param e {Event}
   */
  receiveMessage = e => {
    const message = e.data;

    if (e.origin === url[this.environment].originCashier) {
      const element = window.document.querySelector('#' + this.cardNumberInput + '-div');
      const elementExpDate = window.document.querySelector('#' + this.expireDateInput + '-div');
      const response = JSON.parse(message);
      if (response) {
        if (response.code === '406') {
          this.validPAN = false;
          if (element) {
            element.style.border = '1px solid #f00';
          }
        } else if (response.validation !== undefined && +response.validation[0].code === 413) {
          this.validPAN = false;
          if (element) {
            element.style.border = '1px solid #f00';
          }
        } else if (response.code === '202' || (Array.isArray(response) && response[0].code === '202')) {
          this.validPAN = true;
          if (element) {
            element.style.border = '1px solid #ddd';
          }
        } else if (+response.code === 400 && this.onSubmitPromiseReject !== false) {
          if (response.message.indexOf('The field expDate') !== -1) {
            if (elementExpDate) {
              elementExpDate.style.border = '1px solid #f00';
            }
          } else {
            this.validPAN = false;
            if (element) {
              element.style.border = '1px solid #f00';
            }
          }
          this.onSubmitPromiseReject(Error('Invalid EPG Response'));
        } else if (response.code === '0' && response.action === 'pan-loaded' && !this.fieldsCustomized) {
          this.panInputLoaded = true;
          this.customizeFields();
        }
        if (!this.fieldsCustomized) {
          this.customizeFields();
        }
      }
    }
  };

  /**
   *
   */
  customizeFields = () => {
    if (!this.fieldsCustomized) {
      const inputExpiration = window.document.getElementById(this.expireDateInput);
      const inputExpirationDiv = window.document.getElementById(this.expireDateInput + '-div');
      const rememberMeDiv = window.document.getElementById(this.rememberMeInput + '-div');
      const inputExpirationCloned = inputExpiration.cloneNode(true);
      inputExpirationCloned.id = inputExpiration.id + '-custom';
      inputExpirationCloned.pattern = '^(0[1-9]|1[0-2])( / )[0-9]{2}$';
      inputExpirationCloned.oninput = e => {
        let value = inputExpirationCloned.value;
        if (/\D\/$/.test(value)) {
          value = value.substr(0, value.length - 3);
        }
        const values = value.split(' / ').map(v => v.replace(/\D/g, ''));
        if (values[0]) {
          values[0] = this.checkValue(values[0], 12);
        }
        const output = values.map((v, i) => (v.length === 2 && i < 2 ? v + ' / ' : v));
        inputExpirationCloned.value = output.join('').substr(0, 7);
      };
      inputExpirationCloned.onchange = e => {
        inputExpiration.value = inputExpirationCloned.value.split('/').reduce((str, val) => str + val.trim(), String());
      };
      inputExpirationDiv.appendChild(inputExpirationCloned);
      inputExpiration.type = 'hidden';
      rememberMeDiv.style.display = 'none';
      this.fieldsCustomized = true;
    }
  };

  checkValue = (str, max) => {
    if (str.charAt(0) !== '0' || str === '00') {
      let num = parseInt(str, 10);
      if (isNaN(num) || num <= 0 || num > max) num = 1;
      str = num > parseInt(max.toString().charAt(0), 10) && num.toString().length === 1 ? '0' + num : num.toString();
    }
    return str;
  };

  /**
   *
   * @param onSubmit {function}
   * @param validForm {boolean}
   * @param inputList {Object}
   * @param resolve {function}
   * @param reject {function}
   */
  validatePayment = (onSubmit, validForm, inputList, resolve, reject) => {

    if (this.prepayToken !== false) {
      onSubmit(validForm, inputList, resolve, reject, true);
    } else if (
      this.validPAN &&
      checkInputValidity(this.holderNameInput) &&
      checkInputValidity(this.expireDateInput) &&
      checkInputValidity(this.cvcInput)
    ) {
      this.onSubmitPromiseResolve = resolve;
      this.onSubmitPromiseReject = reject;
      // Element que apareix dinàmicament del TPV, no hi tinc mes control
      window.document.getElementById(this.submitButton).click();
    } else {
      this.onSubmitPromiseResolve = resolve;
      this.onSubmitPromiseReject = reject;
      window.document.getElementById(this.submitButton).click();
      window.scrollBy(0, -65);
      reject(Error('Credit card data isn\'t valid'));
    }
  };


  /**
   *
   * @returns {HTMLElement}
   */
  addScriptTag = () => {
    const scriptEPG = document.createElement('script');
    scriptEPG.setAttribute('src', url[this.environment].scriptTag);
    document.head.appendChild(scriptEPG);
    return scriptEPG;
  };

  /**
   *
   * @param authToken {string}
   * @param callback {function}
   * @param lang {string}
   * @param formId {string}
   */
  renderCashier = (authToken, callback, lang, formId) => {
    window.EPGJS_COMM.setEpgBaseUrl(url[this.environment].cashier);
    window.EPGJS_STYLE.setCssTheme(window.EPGJS_STYLE.DEFAULT_BOOTSTRAP_THEME);
    window.EPGJS_COMM.setMerchantPrePayCallback(callback);
    window.EPGJS.setLang(lang);
    window.EPGJS.setI18n(i18nEPG);
    window.EPGJS.renderQuickDepositByPaysol(authToken, this.cashierContainer, formId, 'creditcards');
    setTimeout(() => {
      this.customizeFields();
    }, 5000);
  };
}
